import React from 'react';
import { InView } from 'react-intersection-observer';

import LazyImgixImage from '@components/LazyImgixImage';
import useEventTracking from '@hooks/useEventTracking';
import { ImpressionElement, impression } from '@tracking';

import { BENEFIT_ROWS } from './constants';

const SubscriptionBenefitsSection = () => {
  const { trackEvent } = useEventTracking();

  return (
    <section className="pt-64 sm:pt-112">
      <h2 className="mb-64 mt-0 text-center font-suisse-works text-headline-sm text-black sm:text-headline-lg md:text-headline-xl">
        With Your Annual Subscription
      </h2>

      <div className="flex flex-col gap-48 sm:gap-96">
        {BENEFIT_ROWS.map(({ title, paragraphs, footnote, imageUrl }) => (
          <InView
            key={title}
            onChange={(inView) => {
              inView &&
                trackEvent(
                  impression({
                    impressionElement: ImpressionElement.BenefitsSection,
                    context: title,
                  })
                );
            }}
            triggerOnce
          >
            <div className="flex flex-col gap-24 sm:flex-row sm:items-center sm:gap-[74px]">
              <div className="flex flex-col gap-8 sm:w-[45%] xl:w-[500px]">
                <h3 className="m-0 font-suisse-works text-headline-xxs text-black sm:text-headline-sm md:text-headline-md">
                  {title}
                </h3>
                <div className="flex flex-col gap-8 text-black">
                  {paragraphs.map((p) => (
                    <p key={p} className="m-0 font-suisse-neue text-body-lg">
                      {p}
                    </p>
                  ))}
                </div>
                {footnote && (
                  <span className="font-suisse-intl-mono text-overline-md">{footnote}</span>
                )}
              </div>
              <div className="w-full sm:w-[55%] xl:w-[600px]">
                <LazyImgixImage className="h-auto w-full" src={imageUrl} />
              </div>
            </div>
          </InView>
        ))}
      </div>
    </section>
  );
};

export default SubscriptionBenefitsSection;
